import React from 'react';

export const tableColumns = [
  {
    Header: `Students`,
    columns: [
      {
        Header: 'Opportunity ID',
        width: 200,
        accessor: 'opportunity_id',
        Cell: ({ value }) => {
          return value ? (
            <a
              href={`https://cuemath.superleap.com/opportunity/records/${value}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {value}
            </a>
          ) : null;
        },
      },
      {
        Header: 'Student Name',
        width: 200,
        accessor: 'student_name',
      },
      {
        Header: 'Grade',
        width: 160,
        accessor: 'student_grade',
      },
      {
        Header: 'Stage',
        width: 200,
        accessor: 'stage',
      },
      {
        Header: 'Leap Profile',
        width: 200,
        Cell: ({ original: { intel_enrollment_id_href } }) => {
          return (
            <a target="_blank" href={intel_enrollment_id_href} rel="noopener noreferrer">
              {intel_enrollment_id_href && 'Leap Profile'}
            </a>
          );
        },
      },
      {
        Header: 'Phone Number',
        width: 200,
        accessor: 'phone',
      },
      {
        Header: 'Time Zone',
        width: 200,
        accessor: 'timezone',
      },
      {
        Header: 'Created On',
        width: 200,
        accessor: 'created_on',
      },
      {
        Header: 'Last Modified On',
        width: 200,
        accessor: 'updated_on',
      },
      {
        Header: 'Lead Owner',
        width: 200,
        accessor: 'OwnerIdEmailAddress',
      },
      {
        Header: 'Qualified Bucket',
        width: 200,
        accessor: 'mx_Qualified_Bucket_Leads',
      },
      {
        Header: 'Demo Profile',
        width: 200,
        accessor: 'mx_Demo_Profile',
        Cell: ({ original: { mx_Demo_Profile } }) => {
          return (
            <a target="_blank" href={mx_Demo_Profile} rel="noopener noreferrer">
              {mx_Demo_Profile && 'Demo Profile Link'}
            </a>
          );
        },
      },
      {
        Header: 'Demo Feedback',
        width: 200,
        accessor: 'student_classroom_id',
        Cell: ({ value }) => {
          return (
            <a
              href={`https://leap-admin.cuemath.com/demo/${value}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {value && 'Demo Feedback'}
            </a>
          );
        },
      },
      {
        Header: 'CM Phone Number',
        width: 200,
        accessor: 'mx_CM_Phone',
      },
      {
        Header: 'Sibling Phone Number',
        width: 200,
        accessor: 'mx_Sibling_Phone_Number',
      },
      {
        Header: 'Scheduling Owner',
        width: 200,
        accessor: 'mx_Scheduling_Owner',
      },
      {
        Header: 'Demo Owner',
        width: 200,
        accessor: 'mx_Demo_Owner',
      },
      {
        Header: 'Payment Owner',
        width: 200,
        accessor: 'mx_Payment_Owner',
      },
      {
        Header: 'Lead Source',
        width: 200,
        accessor: 'Source',
      },
      {
        Header: 'Lead Origin',
        width: 200,
        accessor: 'Origin',
      },
      {
        Header: 'Created By',
        width: 200,
        accessor: 'CreatedByName',
      },
      {
        Header: 'Teacher Name',
        width: 200,
        accessor: 'mx_Teacher_Name',
      },
      {
        Header: 'Teacher Phone Number',
        width: 200,
        accessor: 'mx_Teacher_Phone_Number',
      },
      {
        Header: 'Teacher Email',
        width: 200,
        accessor: 'mx_Teacher_Email',
      },
      {
        Header: 'Demo Date',
        width: 200,
        accessor: 'mx_Demo_Date',
      },
    ],
  },
];
